const toEmptyConfig = (data) => ({
  chart: {
    height: 100,
  },
  title: {
    text: `${data
      .map((event) => `${event.id === '' ? '' : `${event.id}.`}${event.name}`)
      .join(', ')} has no data`,
  },
  credits: {
    enabled: false,
  },
});

export default toEmptyConfig;
